import {cn} from '../../../lib/utils';
import {IconProps} from '../../../app/data/types/Icon';

export default function InfoBoxIcon({className}: IconProps){
	return (
		<svg className={cn('h-6 w-6 fill-blue-dark-2', className)} focusable="false" aria-hidden="true" viewBox="0 0 24 24">
			<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"></path>
		</svg>
	)
}
